class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ADDED BY SD - 25/10/25 TO TRY TO RESOLVE GOOGLE TAGS

document.addEventListener("DOMContentLoaded", function () {

  window.dataLayer = window.dataLayer || [];

  // Helper to send Add to Cart events
  function sendAddToCartEvent(item) {
    if (!item || !item.id) return;
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        items: [{
          item_id: item.id.toString(),
          item_name: item.title,
          price: item.price / 100,
          quantity: item.quantity,
          item_variant: item.variant_title,
          item_category: item.product_type,
          item_brand: item.vendor,
        }]
      }
    });
  }

  // 1️⃣ AJAX cart drawer
  document.addEventListener("cart:updated", function (event) {
    const cart = event.detail.cart;
    if (cart.items && cart.items.length) {
      cart.items.forEach(function (item) {
        if (!item._littledata_sent) {
          sendAddToCartEvent(item);
          item._littledata_sent = true;
        }
      });
    }
  });

  // 2️⃣ Standard Add to Cart buttons/forms
  document.querySelectorAll('form[action^="/cart/add"] [type="submit"]').forEach(function(btn) {
    btn.addEventListener("click", function(event) {
      const form = btn.closest('form');
      if (!form) return;

      const formData = new FormData(form);
      const item = {
        id: formData.get('id'),
        title: form.dataset.productTitle || "Unknown",
        price: parseFloat(form.dataset.productPrice || 0),
        quantity: parseInt(formData.get('quantity') || 1),
        variant_title: form.dataset.productVariant || "Default",
        product_type: form.dataset.productType || "Default",
        vendor: form.dataset.productVendor || "Default",
      };

      sendAddToCartEvent(item);
    });
  });

  // 3️⃣ Quick Order / Quick Add buttons
  document.querySelectorAll('.quick-order-add, .quick-add-button').forEach(function(btn) {
    btn.addEventListener("click", function(event) {
      const productEl = btn.closest('[data-product-id]');
      if (!productEl) return;

      const item = {
        id: productEl.dataset.variantId || productEl.dataset.productId,
        title: productEl.dataset.productTitle || "Unknown",
        price: parseFloat(productEl.dataset.productPrice || 0),
        quantity: parseInt(productEl.dataset.quantity || 1),
        variant_title: productEl.dataset.productVariant || "Default",
        product_type: productEl.dataset.productType || "Default",
        vendor: productEl.dataset.productVendor || "Default",
      };

      sendAddToCartEvent(item);
    });
  });

  // 4️⃣ Shopify Buy Buttons (embedded products)
  window.ShopifyBuy && window.ShopifyBuy.UI && window.ShopifyBuy.UI.onReady(function (ui) {
    ui.on('cart:add', function (item) {
      sendAddToCartEvent(item);
    });
  });

});
